import React from "react";
import { formatPriceRangeForEntity } from "../helpers/formatting";

const AccommodationSummary = ({ accommodation }) => {
  return (
    <>
      <strong>{accommodation.is_private ? 'Private Accommodation' : 'Semi-Private Accommodation'}</strong>
      Monthly Price: <em>{formatPriceRangeForEntity(accommodation)} {accommodation.all_inclusive_price ? '(all-inclusive)' : ''}</em><br />
      {accommodation.notes && accommodation.notes.trim().length > 0 ? (
        <>
          <span>Notes: {accommodation.notes}</span><br />
        </>
      ) : ''}
      {accommodation.price_notes && accommodation.price_notes.trim().length > 0 ? (
        <>
          <span>Pricing Notes: {accommodation.price_notes}</span><br />
        </>
      ) : ''}
    </>
  )
};

export default AccommodationSummary;
